import { render } from "./NuovaPrenotazione.vue?vue&type=template&id=56e2f742"
import script from "./NuovaPrenotazione.vue?vue&type=script&lang=js"
export * from "./NuovaPrenotazione.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__